import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { ApiService } from '../../core/upgraded-providers';

@Injectable()
export class MyOrdersResolver implements Resolve<any> {

    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): angular.IPromise<any> {
        return this._apiService
            .get('game/market/my-orders', { })
            .then(({ list, shards }) => {
                let responseData = [];

                if (shards) {
                    responseData = Object.entries<any[]>(shards).map(([name, orders]) => ({
                        name,
                        orders
                    }));
                }

                if (list) {
                    responseData = [{
                        name: null,
                        orders: list
                    }];
                }

                return responseData.filter(({ orders }) => orders.length);
            });
    }
}
